import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, defineProperty as _defineProperty, objectSpread as _objectSpread } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getMarginBottomClass, Button, combineEventHandlers, Link, IconChevronLeftThick, marginBottomLevels, withContext } from '@piggybank/core';
import omit from 'lodash/fp/omit';
import isEmpty from 'lodash/fp/isEmpty';
import { connect } from 'formik';
import { Consumer } from '../Wizard/context.js';
import styles from './navigation.css.js';
var Navigation = connect(function (_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'nav' : _ref$component,
      children = _ref.children,
      currentPage = _ref.currentPage,
      _ref$disablePrevious = _ref.disablePrevious,
      disablePrevious = _ref$disablePrevious === void 0 ? false : _ref$disablePrevious,
      formik = _ref.formik,
      ownOnNext = _ref.ownOnNext,
      contextOnNext = _ref.contextOnNext,
      onPrevious = _ref.onPrevious,
      isLastPage = _ref.isLastPage,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? 0 : _ref$marginBottom,
      nextSlot = _ref.nextSlot,
      previousSlot = _ref.previousSlot,
      _ref$textMap = _ref.textMap,
      textMap = _ref$textMap === void 0 ? {
    previous: 'Back',
    next: 'Continue',
    submit: 'Submit'
  } : _ref$textMap,
      sticky = _ref.sticky,
      props = _objectWithoutProperties(_ref, ["component", "children", "currentPage", "disablePrevious", "formik", "ownOnNext", "contextOnNext", "onPrevious", "isLastPage", "marginBottom", "nextSlot", "previousSlot", "textMap", "sticky"]);

  return React.createElement(Component, _extends({
    className: cn(_defineProperty({}, styles['Navigation--sticky'], sticky), getMarginBottomClass(marginBottom))
  }, omit(['onNext'], props)), React.createElement("div", {
    className: cn(_defineProperty({}, styles.wrapper, sticky))
  }, sticky && children && React.createElement("div", {
    className: styles.navigationContent
  }, children), React.createElement("div", {
    className: cn(styles['Navigation'], _defineProperty({}, styles['Navigation--noBack'], disablePrevious || currentPage === 0))
  }, nextSlot ? nextSlot : isEmpty(formik) ? React.createElement(Button, {
    onClick: combineEventHandlers(ownOnNext, contextOnNext),
    type: "button"
  }, isLastPage ? textMap.submit : textMap.next) : React.createElement(Button, {
    onClick: combineEventHandlers(ownOnNext, function (e) {
      e.preventDefault();

      if (!formik.isSubmitting) {
        formik.submitForm();
      }
    }),
    type: "submit"
  }, isLastPage ? textMap.submit : textMap.next), previousSlot || !disablePrevious && currentPage > 0 && React.createElement(Link, {
    elementType: "button",
    type: "button",
    onClick: function onClick() {
      return onPrevious(formik.values);
    },
    iconSlotLeft: React.createElement("span", {
      className: cn(styles.chevronWrapper)
    }, React.createElement(IconChevronLeftThick, {
      inline: true
    })),
    hoverUnderline: true,
    buttonPadding: true
  }, React.createElement("span", {
    className: cn(styles.text)
  }, textMap.previous)))));
});
Navigation.displayName = 'Navigation';
var sharedPropTypes = {
  component: PropTypes.string,

  /** docgen-from-context:<Wizard/> */
  disablePrevious: PropTypes.bool,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),
  nextSlot: PropTypes.node,
  previousSlot: PropTypes.node,
  textMap: PropTypes.shape({
    previous: PropTypes.node,
    next: PropTypes.node,
    submit: PropTypes.node
  })
};
Navigation.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread({}, sharedPropTypes, {
  /** docgen-from-context:<Wizard/> */
  currentPage: PropTypes.number.isRequired,

  /** docgen-ignore */
  ownOnNext: PropTypes.func,

  /** docgen-ignore */
  contextOnNext: PropTypes.func,

  /** docgen-from-context:<Wizard/> */
  onPrevious: PropTypes.func.isRequired,

  /** docgen-from-context:<Wizard/> */
  isLastPage: PropTypes.bool.isRequired,
  sticky: PropTypes.bool,
  children: PropTypes.node
}) : {};
var NavigationWithContext = withContext(Consumer, function (value, ownProps) {
  return {
    currentPage: value.currentPage,
    disablePrevious: value.disablePrevious,
    ownOnNext: ownProps.onNext,
    contextOnNext: value.onNext,
    onPrevious: combineEventHandlers(ownProps.onPrevious, value.onPrevious),
    isLastPage: value.isLastPage
  };
})(Navigation);
NavigationWithContext.propTypes = _objectSpread({}, sharedPropTypes, {
  /** docgen-from-context:<Wizard/> */
  onNext: PropTypes.func,

  /** docgen-from-context:<Wizard/> */
  onPrevious: PropTypes.func,

  /** docgen-from-context:<Wizard/> */
  isLastPage: PropTypes.bool
});
export default NavigationWithContext;
export { Navigation };